import { tokens } from '@fluentui/react-components';
import {
  CircleRegular,
  CircleHalfFillRegular,
  CheckmarkCircleRegular,
  DismissCircleRegular,
  type FluentIcon,
} from '@fluentui/react-icons';
import { STATUS_BLUE } from '@shared/constants/colors.constants';
import { TERMINOLOGY } from '@shared/i18n';
import { ETaskPriority, ETaskStatus } from './types';

export const TASK_STATUS_METADATA: Record<ETaskStatus, { label: string; color: string; icon: FluentIcon }> = {
  [ETaskStatus.NOT_STARTED]: { label: 'Not started', color: tokens.colorNeutralForeground3, icon: CircleRegular },
  [ETaskStatus.IN_PROGRESS]: { label: 'In progress', color: STATUS_BLUE, icon: CircleHalfFillRegular },
  [ETaskStatus.DONE]: { label: 'Done', color: tokens.colorBrandForeground1, icon: CheckmarkCircleRegular },
  [ETaskStatus.CANCELLED]: { label: 'Cancelled', color: tokens.colorNeutralForeground3, icon: DismissCircleRegular },
};
export const TASK_PRIORITY_LABELS: Record<ETaskPriority, string> = {
  [ETaskPriority.NONE]: 'None',
  [ETaskPriority.LOW]: 'Low',
  [ETaskPriority.MEDIUM]: 'Medium',
  [ETaskPriority.HIGH]: 'High',
};

export const TASKS_ENDPOINT = '/tasks';
export const TASKS_QUERY_KEY = 'tasks';

export const TASKS_TABLE_ID = 'project-tasks-table';
export const TASK_COLUMN_LABELS = {
  title: TERMINOLOGY.task.upper,
  status: 'Status',
  assignee: 'Assignee',
  dueDate: 'Due date',
  priority: 'Priority',
};
export const TASK_COLUMN_WIDTHS = { status: 144, assignee: 112, dueDate: 128, priority: 128 };

export const TASK_QUERY_KEY = 'task';
export const TASK_DIALOG_PARAM = 'task';
export const TASK_STATUS_PARAM = 'status';
// Assignee filter value for tasks without an assignee; the list request sends it as `unassigned=true`.
export const TASK_UNASSIGNED_VALUE = 'unassigned';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/tasks/configs/tasks.config.ts
export const TASK_DESCRIPTION_MAX_LENGTH = 10000;
export const TASK_STATUSES = Object.values(ETaskStatus).map((value) => ({ value, ...TASK_STATUS_METADATA[value] }));
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/tasks/configs/tasks.config.ts
export const TASK_SEARCH_MAX_LENGTH = 200;
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/tasks/configs/tasks.config.ts
// Upper bound for the links one save adds, and for the links it removes; a task has no total limit.
export const TASK_LINKED_ITEMS_MAX_COUNT = 100;
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/tasks/configs/tasks.config.ts
export const TASK_DUE_SOON_DAYS = 7;

export const TASK_DRAG_TYPE = 'project-task';

// Linked items a task dialog shows before "Show N more".
export const TASK_LINKED_ITEMS_PREVIEW_COUNT = 3;
// Linked items a task row shows under its title before "+N".
export const TASK_LIST_LINKED_ITEMS_COUNT = 2;
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/projects/tasks/src/flags.ts
// Linked items under task titles in the task list. Off for now: the backend then skips resolving them. Turn it on in
// both repositories together.
export const TASK_LIST_LINKED_ITEMS_ENABLED = false;
